import React from "react";
import { Avatar, Dropdown, Flex, Menu, MenuProps } from "antd";
import { Layout } from "antd";
import {
  HomeOutlined,
  SettingOutlined,
  CarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { persistor } from "../reudx-toolkit/store";
import CustomTitle from "../components/CustomTitle";
import { useToken } from "../common/helper";
import { useWebSocket } from "../context/WebSocketContext";

const { Sider } = Layout;

function CustomHeader() {
  const { webSocketService, setSelectedUserID } = useWebSocket();
  const navigate = useNavigate();
  const { removeToken, setUserId, userID } = useToken();

  const items = [
    { label: "Profile", key: "1" },
    { label: "Logout", key: "2" },
  ];

  const handleMenuClick = (e) => {
    if (e.key === "1") {
      navigateToProfile();
    } else if (e.key === "2") {
      removeToken();
      setUserId(null);
      setSelectedUserID(null);
      persistor.flush().then(() => {
        persistor.purge();
        localStorage.clear();
        navigate("/login");
      });
      webSocketService.disconnect();
    }
  };

  const navigateToProfile = () => {
    navigate("/settings/profile");
  };

  return (
    <>
      <Flex
        align="center"
        justify="space-between"
        style={{ height: "inherit" }}
      >
        <CustomTitle
          text={"ZoomLogi"}
          color={"#3D81FF"}
          fontSize={16}
          fontWeight={600}
          lineHeight="28px"
          marginBottom={0}
        />

        <div>
          <Dropdown
            menu={{ items, onClick: handleMenuClick }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Avatar
              size={36}
              icon={<UserOutlined />}
              style={{ cursor: "pointer" }}
            />
          </Dropdown>
        </div>
      </Flex>
    </>
  );
}

export default CustomHeader;
